import { FEATURES } from '@constants/Text'
import { registrarTourDoModulo } from '@modules/central-config/utils/tour-registry'
import { registrar } from '@modules/aawz-intelligence-v2/ui-registry'
import registryFeeFixo from './ia/registry'
import { registrarFormularioFiltrosClientes } from './ia/formulario-filtros-clientes'
import { registrarConfirmadorDeSimulacao } from './ia/confirmadores'
import * as feeFixoStore from './store'
import * as feeFixoIaStore from './store/ia'
import { montarTourDoFeeFixo } from './utils/iniciar-tour-guiado'
import { MODULE_KEY_FEE_FIXO } from './constants/tour-fee-fixo'

export const feeFixoModule = ({ store }) => {
  store.registerModule('feeFixo', { ...feeFixoStore, namespaced: true })
  // Chat do Especialista Fee-Based (drawer). Namespace separado do
  // `aawz-intelligence-v2` para não misturar conversa nem persona.
  store.registerModule('feeFixoIa', { ...feeFixoIaStore, namespaced: true })

  // Tour guiado: o MÓDULO se registra, o central-config só consulta — é o que
  // permite `startTaskNavigation` guiar sem importar fee-fixo. Registrar aqui
  // (e não numa view) cobre TODA superfície de "Iniciar etapa" de uma vez: a
  // barra embutida na Visão Geral, o accordion da Jornada, o card da Home e o
  // CTA da landing.
  registrarTourDoModulo(MODULE_KEY_FEE_FIXO, montarTourDoFeeFixo)

  // Os seis cartões do módulo dentro da conversa (spec-001 do
  // `project-plataforma-por-chat`, [T016]). Mesmo princípio do tour acima: o
  // MÓDULO se registra e o agregado só consulta — é o que permite o
  // `chat-message.vue` desenhar um cartão do fee-fixo sem importar nada daqui.
  //
  // Aqui, e não numa view: o cartão pode chegar em QUALQUER conversa (a do
  // guia, a do Especialista, o chat do intelligence-v2), e registrar na view
  // deixaria o mesmo `tool_result` virar cartão numa tela e `fallback-card` na
  // outra. `registerAllModules` roda uma vez, no boot, antes de qualquer
  // thread montar.
  //
  // ⚠️ `registrar` RECUSA chave repetida (por desenho — override silencioso
  // entre módulos é bug). Uma segunda chamada de `feeFixoModule` no mesmo
  // contexto estoura aqui, e é assim que se descobre que ela existe.
  registrar(registryFeeFixo)

  // O recorte de clientes como formulário que a IA sabe preencher (spec-010,
  // [T019]). Mesmo princípio das duas linhas acima: o MÓDULO se registra. Antes
  // disso o mapa de formulários da tool `preencher` importava
  // `fee-fixo/utils/filtro-tipado` direto — o achado I-5 da review da spec-001.
  registrarFormularioFiltrosClientes()

  // Confirmar a simulação a partir de uma conversa que NÃO é do módulo (a
  // Home IA). O canal genérico `@respond` manda só "Confirmo" ao modelo, e o
  // commit da simulação exige o depósito dos `resultados` calculados no
  // navegador — medido em 04/09/2026: sem esta linha o cenário não era
  // gravado e o modelo respondia que a confirmação "acontece na tela do Fee
  // Lab". Aqui, e não numa view, pela mesma razão do `registrar` acima.
  registrarConfirmadorDeSimulacao()
}

export const PERMISSION = FEATURES.FEE_FIXO
